import { useMutation, useQuery } from "react-query";
import type { ItandiAccountSession } from "../models/ItandiAccountSession";
import { ApiClient } from "../utils/api";

export const useItandiAccountSessions = () => {
	return useQuery<ItandiAccountSession>("itandi_account_sessions", async () => {
		const response = await ApiClient.get("/itandi_account_sessions");

		return response.data;
	});
};

export const useDeleteItandiAccountSessions = () => {
	return useMutation(
		async () => {
			const response = await ApiClient.delete(`/itandi_account_sessions`);

			return response.data;
		},
		{
			onSuccess: (data: { url: string }) => {
				window.location.replace(data.url);
			}
		}
	);
};
